module.exports = __webpack_public_path__ + "img/EducationalCourses.93010c19.svg";